export default "__VITE_ASSET__h5kAo8XA__"